export const selectRetireConstants = (state) =>
	state.entities.investor_application?.retire_constants;

export const selectFilingStatus = (state) =>
	state.entities.investor_application?.filing_status;

export const selectHouseholdIncomeBracket = (state) =>
	state.entities.investor_application?.household_income_bracket;
